var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpathymap(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 296,
    viewBox: "0 0 360 296",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_304_984)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 138.38,
    r: 100.38,
    fill: "url(#paint0_radial_304_984)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.893 133.933V137.101H110.002V140.045H104.893V143.48H110.671V146.536H101.079V130.877H110.671V133.933H104.893Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.03 133.955C130.576 133.955 131.803 134.424 132.71 135.361C133.632 136.297 134.093 137.599 134.093 139.264V146.536H130.301V139.777C130.301 138.974 130.085 138.357 129.654 137.926C129.238 137.48 128.658 137.257 127.914 137.257C127.171 137.257 126.583 137.48 126.152 137.926C125.736 138.357 125.527 138.974 125.527 139.777V146.536H121.735V139.777C121.735 138.974 121.52 138.357 121.088 137.926C120.672 137.48 120.092 137.257 119.348 137.257C118.605 137.257 118.017 137.48 117.586 137.926C117.17 138.357 116.962 138.974 116.962 139.777V146.536H113.147V134.089H116.962V135.651C117.348 135.13 117.854 134.721 118.478 134.424C119.103 134.111 119.809 133.955 120.598 133.955C121.534 133.955 122.367 134.156 123.096 134.558C123.839 134.959 124.419 135.532 124.836 136.275C125.267 135.591 125.855 135.033 126.598 134.602C127.342 134.171 128.152 133.955 129.03 133.955Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.575 135.851C140.947 135.271 141.46 134.803 142.115 134.446C142.769 134.089 143.535 133.911 144.412 133.911C145.438 133.911 146.368 134.171 147.2 134.691C148.033 135.212 148.688 135.955 149.163 136.922C149.654 137.889 149.9 139.011 149.9 140.29C149.9 141.569 149.654 142.7 149.163 143.681C148.688 144.648 148.033 145.399 147.2 145.934C146.368 146.454 145.438 146.715 144.412 146.715C143.55 146.715 142.784 146.536 142.115 146.179C141.46 145.822 140.947 145.361 140.575 144.796V152.47H136.761V134.089H140.575V135.851ZM146.018 140.29C146.018 139.339 145.75 138.595 145.215 138.06C144.695 137.509 144.048 137.234 143.274 137.234C142.516 137.234 141.869 137.509 141.334 138.06C140.813 138.61 140.553 139.361 140.553 140.313C140.553 141.264 140.813 142.015 141.334 142.566C141.869 143.116 142.516 143.391 143.274 143.391C144.033 143.391 144.68 143.116 145.215 142.566C145.75 142.001 146.018 141.242 146.018 140.29Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.142 140.29C151.142 139.011 151.38 137.889 151.856 136.922C152.347 135.955 153.009 135.212 153.841 134.691C154.674 134.171 155.604 133.911 156.63 133.911C157.507 133.911 158.273 134.089 158.927 134.446C159.597 134.803 160.11 135.271 160.466 135.851V134.089H164.281V146.536H160.466V144.774C160.095 145.354 159.574 145.822 158.905 146.179C158.251 146.536 157.485 146.715 156.607 146.715C155.596 146.715 154.674 146.454 153.841 145.934C153.009 145.399 152.347 144.648 151.856 143.681C151.38 142.7 151.142 141.569 151.142 140.29ZM160.466 140.313C160.466 139.361 160.199 138.61 159.663 138.06C159.143 137.509 158.503 137.234 157.745 137.234C156.987 137.234 156.34 137.509 155.804 138.06C155.284 138.595 155.024 139.339 155.024 140.29C155.024 141.242 155.284 142.001 155.804 142.566C156.34 143.116 156.987 143.391 157.745 143.391C158.503 143.391 159.143 143.116 159.663 142.566C160.199 142.015 160.466 141.264 160.466 140.313Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M173.978 143.302V146.536H172.037C170.654 146.536 169.576 146.202 168.803 145.532C168.029 144.848 167.643 143.74 167.643 142.209V137.257H166.126V134.089H167.643V131.055H171.457V134.089H173.956V137.257H171.457V142.253C171.457 142.625 171.546 142.893 171.725 143.056C171.903 143.22 172.201 143.302 172.617 143.302H173.978Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M183.754 133.955C185.181 133.955 186.327 134.431 187.189 135.383C188.052 136.32 188.483 137.614 188.483 139.264V146.536H184.691V139.777C184.691 138.945 184.475 138.298 184.044 137.837C183.613 137.376 183.033 137.145 182.304 137.145C181.575 137.145 180.995 137.376 180.564 137.837C180.133 138.298 179.917 138.945 179.917 139.777V146.536H176.103V130.029H179.917V135.762C180.304 135.212 180.832 134.773 181.501 134.446C182.17 134.119 182.921 133.955 183.754 133.955Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M203.848 134.089L196.041 152.448H191.937L194.792 146.112L189.728 134.089H193.989L196.866 141.874L199.722 134.089H203.848Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M227.689 130.877V146.536H223.874V137.145L220.372 146.536H217.294L213.769 137.123V146.536H209.955V130.877H214.461L218.855 141.718L223.205 130.877H227.689Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M229.673 140.29C229.673 139.011 229.911 137.889 230.387 136.922C230.878 135.955 231.54 135.212 232.372 134.691C233.205 134.171 234.135 133.911 235.161 133.911C236.038 133.911 236.804 134.089 237.458 134.446C238.127 134.803 238.641 135.271 238.997 135.851V134.089H242.812V146.536H238.997V144.774C238.626 145.354 238.105 145.822 237.436 146.179C236.782 146.536 236.016 146.715 235.138 146.715C234.127 146.715 233.205 146.454 232.372 145.934C231.54 145.399 230.878 144.648 230.387 143.681C229.911 142.7 229.673 141.569 229.673 140.29ZM238.997 140.313C238.997 139.361 238.73 138.61 238.194 138.06C237.674 137.509 237.034 137.234 236.276 137.234C235.518 137.234 234.871 137.509 234.335 138.06C233.815 138.595 233.555 139.339 233.555 140.29C233.555 141.242 233.815 142.001 234.335 142.566C234.871 143.116 235.518 143.391 236.276 143.391C237.034 143.391 237.674 143.116 238.194 142.566C238.73 142.015 238.997 141.264 238.997 140.313Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M249.386 135.851C249.758 135.271 250.271 134.803 250.925 134.446C251.579 134.089 252.345 133.911 253.223 133.911C254.249 133.911 255.178 134.171 256.011 134.691C256.844 135.212 257.498 135.955 257.974 136.922C258.465 137.889 258.71 139.011 258.71 140.29C258.71 141.569 258.465 142.7 257.974 143.681C257.498 144.648 256.844 145.399 256.011 145.934C255.178 146.454 254.249 146.715 253.223 146.715C252.36 146.715 251.594 146.536 250.925 146.179C250.271 145.822 249.758 145.361 249.386 144.796V152.47H245.571V134.089H249.386V135.851ZM254.829 140.29C254.829 139.339 254.561 138.595 254.026 138.06C253.505 137.509 252.858 137.234 252.085 137.234C251.327 137.234 250.68 137.509 250.144 138.06C249.624 138.61 249.364 139.361 249.364 140.313C249.364 141.264 249.624 142.015 250.144 142.566C250.68 143.116 251.327 143.391 252.085 143.391C252.843 143.391 253.49 143.116 254.026 142.566C254.561 142.001 254.829 141.242 254.829 140.29Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_304_984)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 313.631,
    cy: 138.381,
    r: 31.3688,
    fill: "url(#paint1_radial_304_984)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_304_984)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46.3688,
    cy: 138.381,
    r: 31.3688,
    fill: "url(#paint2_radial_304_984)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_304_984",
    x: 20.6159,
    y: 0.237549,
    width: 295.167,
    height: 295.167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -11.8008,
    dy: 9.44061
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.6015
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_304_984"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_304_984",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_304_984",
    x: 223.258,
    y: 69.2493,
    width: 157.144,
    height: 157.143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -11.8008,
    dy: 9.44061
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.6015
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_304_984"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_304_984",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_304_984",
    x: -44.0038,
    y: 69.2493,
    width: 157.144,
    height: 157.143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -11.8008,
    dy: 9.44061
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.6015
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_304_984"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_304_984",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_304_984",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(217 98.6192) rotate(45) scale(95.1636 78.7919)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F8EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_304_984",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(325.194 125.955) rotate(45) scale(29.7386 24.6225)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F8EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_304_984",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.9314 125.955) rotate(45) scale(29.7386 24.6225)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F8EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpathymap);
export default __webpack_public_path__ + "static/media/empathymap.27c63ecfbda5ed8ff0cbc3583bdf204c.svg";
export { ForwardRef as ReactComponent };